import React, { useEffect, useState } from "react";
import { Tabs, Tab, Box, IconButton, Button } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import ListIcon from "@mui/icons-material/List";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import { getDecryptedAccessToken, getDecryptedUserType } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import { useNavigate } from "react-router-dom";

import RiteDepartmentList from "./RiteDepartmentList";
import RiteDepartmentAdd from "./RiteDepartmentAdd";
import RiteDepartmentDetails from "./RiteDepartmentDetails";

const roleBaseMap = {
  super_admin: "/rite-admin",
  admin: "/rite-admin",
  manager: "/rite-manager",
  marketer: "/rite-marketer",
  staff: "/rite-staff",
  developer: "/rite-developer",
};

const RiteDepartmentTabs = () => {

  const navigate = useNavigate();
  const userType = getDecryptedUserType();
  const basePath = roleBaseMap[userType] || "/rite-admin";
const acceessToken = getDecryptedAccessToken()
  const [tabs, setTabs] = useState([]);
  const [selectedTab, setSelectedTab] = useState(1);
  const [departments, setDepartments] = useState([]);

const fetchDepartments = async () => {
  try {

    const res = await ApiServices.get(
      "/api/v1/admin/departments/",
      { Authorization: `Bearer ${acceessToken}` }
    );

    setDepartments(res?.data?.results || []);

  } catch (error) {
    console.error("Error fetching departments:", error);
  }
};

  useEffect(() => {
    fetchDepartments();
  }, []);

  const openDepartmentTab = (department) => {

    const existingIndex = tabs.findIndex((t) => t.id === department.id);

    if (existingIndex === -1) {
      const newTabs = [...tabs, department];
      setTabs(newTabs);
      setSelectedTab(newTabs.length + 1);
    } else {
      setSelectedTab(existingIndex + 2);
    }
  };

  const closeTab = (index) => {
    const updated = tabs.filter((_, i) => i !== index);
    setTabs(updated);
    setSelectedTab(1);
  };

  const handleTabChange = (_, value) => {
    setSelectedTab(value);
  };

  return (
    <Box>

      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="scrollable"
      >

        <Tab icon={<BusinessIcon />} label="Add Department" />

        <Tab icon={<ListIcon />} label="Department List" />

        {tabs.map((tab, index) => (
          <Tab
            key={tab.id}
            label={
              <Box display="flex" alignItems="center">
                {tab.title}
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    closeTab(index);
                  }}
                >
                  <CloseIcon fontSize="small"/>
                </IconButton>
              </Box>
            }
          />
        ))}

      </Tabs>

      <Box mt={2}>

        {selectedTab === 0 && (
  <RiteDepartmentAdd onCreated={fetchDepartments}/>
)}

{selectedTab === 1 && (
  <RiteDepartmentList
    departments={departments}
    onOpen={openDepartmentTab}
    onRefresh={fetchDepartments}
  />
)}

{selectedTab > 1 && (
  <RiteDepartmentDetails
    department={tabs[selectedTab - 2]}
    onRefresh={fetchDepartments}
  />
)}

      </Box>
    </Box>
  );
};

export default RiteDepartmentTabs;